// Shared autoplay nudger — the autoplay attribute alone gets
// blocked in some scenarios (iOS Safari with mid-load mute
// property, strict Chrome autoplay policies, brand-new visitors
// with no media-engagement history). This sets the muted
// property explicitly (not just the attribute), then calls play()
// once each element can actually decode a frame, with a
// user-interaction fallback for the rare cases where even
// programmatic play() is blocked.
//
// Targets any <video data-wc-autoplay> on the page — call once
// site-wide from layout/theme.liquid and individual sections
// just need to opt-in by adding the data attribute.
(function () {
  var videos = document.querySelectorAll('video[data-wc-autoplay]');
  if (!videos.length) return;

  // Respect prefers-reduced-motion: a user who's opted out of
  // animations doesn't want autoplaying video either. Pause every
  // target video and bail before attaching the nudgers/listeners.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    for (var k = 0; k < videos.length; k++) {
      try { videos[k].pause(); videos[k].removeAttribute('autoplay'); } catch (e) { /* swallow */ }
    }
    return;
  }

  var pendingPlays = [];

  function attach(v) {
    if (!v || v.tagName !== 'VIDEO') return;
    v.defaultMuted = true;
    v.muted = true;
    var tryPlay = function () {
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () { /* swallow */ });
    };
    if (v.readyState >= 2) tryPlay();
    else v.addEventListener('canplay', tryPlay, { once: true });
    // Stash so the first-interaction handlers below can nudge every video.
    pendingPlays.push(tryPlay);
  }

  for (var i = 0; i < videos.length; i++) attach(videos[i]);

  // First user interaction always satisfies the autoplay gate.
  // Single listener fires every stashed tryPlay across all videos.
  function nudgeAll() {
    for (var j = 0; j < pendingPlays.length; j++) {
      try { pendingPlays[j](); } catch (e) { /* swallow */ }
    }
  }
  document.addEventListener('touchstart', nudgeAll, { once: true, passive: true });
  document.addEventListener('click', nudgeAll, { once: true });
})();
